import { render } from "./HistoryRouteComponent.vue?vue&type=template&id=5a5c3998&scoped=true"
import script from "./HistoryRouteComponent.vue?vue&type=script&lang=js"
export * from "./HistoryRouteComponent.vue?vue&type=script&lang=js"

import "./HistoryRouteComponent.vue?vue&type=style&index=0&id=5a5c3998&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a5c3998"]])

export default __exports__